var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSourceGoogle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 16.9991C22 19.7612 19.7612 22 17.0001 22H6.99995C4.23793 22 2 19.7612 2 16.9991V7.00008C2 4.238 4.23793 2 6.99995 2H17.0001C19.7612 2 22 4.238 22 7.00008L22 16.9991Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2634_41856",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 5,
    width: 14,
    height: 14
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3752 10.707H12.1385V13.2595H15.7221C15.6645 13.6207 15.5351 13.9761 15.3457 14.3001C15.1287 14.6714 14.8604 14.954 14.5853 15.1692C13.7616 15.814 12.8011 15.9458 12.1341 15.9458C10.4492 15.9458 9.00948 14.8335 8.45215 13.3221C8.42965 13.2673 8.41472 13.2106 8.39653 13.1546C8.27337 12.77 8.20608 12.3626 8.20608 11.9391C8.20608 11.4985 8.27895 11.0766 8.41182 10.6782C8.9359 9.10689 10.408 7.93327 12.1353 7.93327C12.4827 7.93327 12.8173 7.97551 13.1346 8.05976C13.8597 8.25229 14.3726 8.6315 14.6869 8.93144L16.5832 7.03464C15.4297 5.95438 13.9259 5.2998 12.1322 5.2998C10.6982 5.29977 9.37427 5.75611 8.28937 6.52733C7.40954 7.15277 6.68796 7.99016 6.20098 8.96269C5.74802 9.86442 5.5 10.8637 5.5 11.9381C5.5 13.0126 5.7484 14.0223 6.20137 14.9157V14.9217C6.6798 15.8702 7.37945 16.6868 8.22979 17.3094C8.97265 17.8533 10.3047 18.5776 12.1322 18.5776C13.1831 18.5776 14.1145 18.3841 14.936 18.0214C15.5286 17.7598 16.0536 17.4185 16.5289 16.98C17.157 16.4005 17.6489 15.6837 17.9847 14.859C18.3204 14.0343 18.5 13.1017 18.5 12.0907C18.5 11.6198 18.4537 11.1416 18.3752 10.707V10.707Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2634_41856)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_2634_41856)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.4043 11.9834C5.41119 13.0409 5.70622 14.132 6.1528 15.0128V15.0189C6.47548 15.6585 6.91648 16.1638 7.41877 16.6645L10.4525 15.5339C9.87855 15.2361 9.79097 15.0536 9.37953 14.7207C8.95907 14.2876 8.64571 13.7905 8.45055 13.2076H8.44269L8.45055 13.2015C8.32216 12.8166 8.3095 12.408 8.30476 11.9834H5.4043Z",
    fill: "url(#paint0_radial_2634_41856)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_2634_41856)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.183 5.2998C11.8854 6.37167 11.9992 7.41356 12.183 8.01977C12.5267 8.02003 12.8578 8.06203 13.1717 8.1457C13.8914 8.33751 14.4005 8.71528 14.7124 9.01409L16.6429 7.0762C15.4993 6.00132 14.123 5.3015 12.183 5.2998Z",
    fill: "url(#paint1_radial_2634_41856)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_2634_41856)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0533 5.24316C11.316 5.24313 9.71204 5.71118 8.39765 6.50221C7.90962 6.79591 7.46176 7.13519 7.06297 7.51248C6.95849 8.35997 7.84503 9.40162 9.60065 9.393C10.4525 8.53622 11.7123 7.98189 13.1145 7.98189C13.1157 7.98189 13.117 7.98198 13.1183 7.98199L13.061 5.24336C13.0584 5.24336 13.0559 5.24316 13.0533 5.24316Z",
    fill: "url(#paint2_radial_2634_41856)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_2634_41856)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9861 12.29L15.6733 13.2112C15.6157 13.5724 15.4863 13.9277 15.2969 14.2518C15.0798 14.623 14.8115 14.9057 14.5365 15.1209C13.7144 15.7643 12.7565 15.8968 12.0897 15.8973C11.4005 17.0963 11.2796 17.6969 12.1382 18.6646C13.2006 18.6638 14.1424 18.4679 14.9731 18.1011C15.5737 17.836 16.1057 17.4901 16.5874 17.0457C17.224 16.4584 17.7225 15.732 18.0628 14.8962C18.403 14.0605 18.585 13.1154 18.585 12.0908L16.9861 12.29Z",
    fill: "url(#paint3_radial_2634_41856)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_2634_41856)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.042 10.6104V13.3568H18.3581C18.4137 12.9806 18.5974 12.4939 18.5974 12.091C18.5974 11.6201 18.5511 11.045 18.4726 10.6104H12.042Z",
    fill: "#3086FF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_2634_41856)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.09106 7.41602C6.70129 7.85159 6.3683 8.33912 6.10429 8.86638C5.65133 9.76812 5.40332 10.8644 5.40332 11.9388C5.40332 11.9539 5.40455 11.9688 5.40465 11.9839C5.60525 12.3767 8.17556 12.3015 8.30511 11.9839C8.30495 11.9691 8.30331 11.9546 8.30331 11.9397C8.30331 11.4991 8.37621 11.1743 8.50907 10.7758C8.67298 10.2844 8.92962 9.83187 9.25779 9.44197C9.33218 9.34497 9.53062 9.13642 9.58851 9.01134C9.61056 8.96369 9.54847 8.93695 9.545 8.92018C9.54112 8.90142 9.45787 8.9165 9.43922 8.90253C9.38 8.85817 9.26274 8.835 9.19153 8.81441C9.03934 8.7704 8.78711 8.67333 8.64702 8.57271C8.20418 8.25467 7.51309 7.87476 7.09106 7.41602Z",
    fill: "url(#paint4_radial_2634_41856)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_2634_41856)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.65667 8.92149C9.68357 9.55683 9.97888 8.6008 10.6616 8.30164L9.47398 5.78613C9.03709 5.97368 8.62432 6.20669 8.24134 6.47894C7.66938 6.88552 7.1643 7.38167 6.74707 7.9463L8.65667 8.92149Z",
    fill: "url(#paint5_radial_2634_41856)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_f_2634_41856)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.07468 15.3385C7.69621 15.8468 7.4804 15.865 7.35352 16.7375C7.59599 16.9792 7.85652 17.2028 8.13336 17.4054C8.87623 17.9493 10.3052 18.6737 12.1327 18.6737C12.1348 18.6737 12.1369 18.6735 12.139 18.6735V15.8478C12.1376 15.8478 12.136 15.8479 12.1347 15.8479C11.4503 15.8479 10.9035 15.6644 10.3428 15.3451C10.2045 15.2664 9.95373 15.4778 9.82624 15.3833C9.65039 15.2529 9.2272 15.4955 9.07468 15.3385Z",
    fill: "url(#paint6_radial_2634_41856)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter8_f_2634_41856)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.332 15.7588V18.6245C11.5877 18.6551 11.8538 18.6736 12.133 18.6736C12.4128 18.6736 12.6836 18.659 12.9466 18.632V15.7781C12.6518 15.8296 12.3742 15.8479 12.135 15.8479C11.8595 15.8479 11.5916 15.8151 11.332 15.7588Z",
    fill: "url(#paint7_linear_2634_41856)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2634_41856",
    x: 4.93422,
    y: 11.5133,
    width: 5.98801,
    height: 5.62082,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.23504,
    result: "effect1_foregroundBlur_2634_41856"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_2634_41856",
    x: 11.5299,
    y: 4.82973,
    width: 5.58274,
    height: 4.65403,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.23504,
    result: "effect1_foregroundBlur_2634_41856"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_2634_41856",
    x: 6.58461,
    y: 4.77308,
    width: 7.00364,
    height: 5.08957,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.23504,
    result: "effect1_foregroundBlur_2634_41856"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_2634_41856",
    x: 11.0631,
    y: 11.6207,
    width: 7.99192,
    height: 7.51438,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.23504,
    result: "effect1_foregroundBlur_2634_41856"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_2634_41856",
    x: 11.5719,
    y: 10.1403,
    width: 7.49582,
    height: 3.68625,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.23504,
    result: "effect1_foregroundBlur_2634_41856"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_2634_41856",
    x: 4.93324,
    y: 6.94594,
    width: 5.12961,
    height: 5.77512,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.23504,
    result: "effect1_foregroundBlur_2634_41856"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_2634_41856",
    x: 3.44222,
    y: 2.48128,
    width: 10.5247,
    height: 9.95833,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.65243,
    result: "effect1_foregroundBlur_2634_41856"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_2634_41856",
    x: 6.88344,
    y: 14.8571,
    width: 5.72531,
    height: 4.28684,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.23504,
    result: "effect1_foregroundBlur_2634_41856"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_f_2634_41856",
    x: 10.862,
    y: 15.2887,
    width: 2.55442,
    height: 3.8552,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.23504,
    result: "effect1_foregroundBlur_2634_41856"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2634_41856",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.3918 16.5649) rotate(-92.3395) scale(6.61782 9.72078)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.141612,
    stopColor: "#1ABD4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247515,
    stopColor: "#6EC30D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.311547,
    stopColor: "#8AC502"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.366013,
    stopColor: "#A2C600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445673,
    stopColor: "#C8C903"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.540305,
    stopColor: "#EBCB03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.615636,
    stopColor: "#F7CD07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.699345,
    stopColor: "#FDCD04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.771242,
    stopColor: "#FDCE05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.860566,
    stopColor: "#FFCE0A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_2634_41856",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(4.55369 -1.12189e-05 -6.4004e-06 5.90236 16.4623 8.87387)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.408458,
    stopColor: "#FB4E5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4540"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_2634_41856",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-7.5925 3.56007 5.7064 8.72241 15.1941 4.38553)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.231273,
    stopColor: "#FF4541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.311547,
    stopColor: "#FF4540"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.457516,
    stopColor: "#FF4640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.540305,
    stopColor: "#FF473F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.699346,
    stopColor: "#FF5138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.771242,
    stopColor: "#FF5B33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.860566,
    stopColor: "#FF6C29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8C18"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_2634_41856",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.2337 17.8052) rotate(-127.454) scale(19.1686 7.07559)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.131546,
    stopColor: "#0CBA65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.209784,
    stopColor: "#0BB86D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.297297,
    stopColor: "#09B479"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.396257,
    stopColor: "#08AD93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.477124,
    stopColor: "#0AA6A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.568425,
    stopColor: "#0D9CC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667385,
    stopColor: "#1893DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.768727,
    stopColor: "#258BF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.858506,
    stopColor: "#3086FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_2634_41856",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.5692 6.49771) rotate(96.6178) scale(7.15806 9.89726)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.366013,
    stopColor: "#FF4E3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.457516,
    stopColor: "#FF8A1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.540305,
    stopColor: "#FFA312"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.615636,
    stopColor: "#FFB60C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.771242,
    stopColor: "#FFCD0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.860566,
    stopColor: "#FECF0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.915033,
    stopColor: "#FECF08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDCD01"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_2634_41856",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.4092 6.42339) rotate(132.119) scale(3.55535 10.028)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.315904,
    stopColor: "#FF4C3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.603818,
    stopColor: "#FF692C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726837,
    stopColor: "#FF7825"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.884534,
    stopColor: "#FF8D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9F13"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_2634_41856",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.9449 19.491) rotate(-151.02) scale(7.34779 9.9709)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.231273,
    stopColor: "#0FBC5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.311547,
    stopColor: "#0FBC5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.366013,
    stopColor: "#0FBC5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.457516,
    stopColor: "#0FBC5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.540305,
    stopColor: "#12BC58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.699346,
    stopColor: "#28BF3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.771242,
    stopColor: "#38C02B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.860566,
    stopColor: "#52C218"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.915033,
    stopColor: "#67C30F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#86C504"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2634_41856",
    x1: 11.332,
    y1: 17.2162,
    x2: 12.9466,
    y2: 17.2162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0FBC5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0CBA65"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSourceGoogle);
export default __webpack_public_path__ + "static/media/source-google.327af21657cfb9a8ce56c45b2fcb0783.svg";
export { ForwardRef as ReactComponent };